import script from "./ChangeStatusForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeStatusForm.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeStatusForm.vue?vue&type=style&index=0&id=34dcc704&lang=scss"

const __exports__ = script;

export default __exports__